import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, STRING, UUID, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import FuelGroup from '@/plugins/sdk/resources/Fuel/Group'
import Carrier from '@/plugins/sdk/resources/Carrier'
import FuelService from '@/plugins/sdk/resources/Fuel/Service'
import Profile from '@/plugins/sdk/resources/Profile'

export default class extends Resource {
  static name = 'fuel'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      code: new STRING(),
      type: new STRING(),
      rate: new STRING(),
      date_start: new DATETIME(),
      date_end: new DATETIME(),
      active: new BOOLEAN(),
      is_most_recent: new BOOLEAN(),
      deleted_at: new DATETIME(),
      group: new ITEM(FuelGroup),
      carrier: new ITEM(Carrier),
      services: new COLLECTION(FuelService),
      profile: new ITEM(Profile)
    }
  }

  static get sortables () {
    return [
      { field: 'name', label: 'Name' },
      { field: 'code', label: 'Code' },
      { field: 'type', label: 'Type' },
      { field: 'rate', label: 'Rate' },
      { field: 'date_start', label: 'Start Date' },
      { field: 'date_end', label: 'End Date' },
      { field: 'created_at', label: 'Created Date' },
      { field: 'updated_at', label: 'Updated Date' },
      { field: 'carrier.name', label: 'Carrier Name' }
    ]
  }
}
